import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../templates/services/base-service.template';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { AppLoginSubjectContainerModel } from '../../models/app/app-login-subject-container.model';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class PlatformUserProfileService implements BaseService {

  public readonly apiUrl: string = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/userprofile';
    
  constructor(protected readonly http: HttpClient) {}

  public resetMobileNumber(data: { appLoginSubjectGuid: string, newMobileNumber: string }, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }/reset-mobile-number`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
